import MaterialPropertyAssigner from "../../../output/assets/materials/material-property-assigner.js";

const ValidProperties = new Set(["side", "skinning", "morphTargets"]);

class ThreeGLRaycastBaseMaterialPropertyAssigner extends MaterialPropertyAssigner {
    constructor() {
        super();
    }

    setProperty(material, property, newValue) {
        if (!ValidProperties.has(property)) return;

        material.setProperty(property, newValue);
    }
}

export default ThreeGLRaycastBaseMaterialPropertyAssigner;
